import React, { Component } from 'react';
import Title from 'grommet/components/Title';
import Paragraph from 'grommet/components/Paragraph';
import Button from 'grommet/components/Button';
import Box from 'grommet/components/Box';
import Header from 'grommet/components/Header';
import Menu from 'grommet/components/Menu';
import Anchor from 'grommet/components/Anchor';
import Sidebar from 'grommet/components/Sidebar';
import Layer from 'grommet/components/Layer';
import App from 'grommet/components/App';
import Split from 'grommet/components/Split';
import Heading from 'grommet/components/Heading';
import BaseIcons from 'grommet/components/icons/base/Close';

class Tutorial extends Component {
    constructor() {
        super();
    }

  render () {
    return (
      <div>
        {/* <Header>Tutorial Tab Title</Header>    
        <Paragraph size='medium'>Tutorial Tab</Paragraph> */}
      </div>
    );
  }  
}

export default Tutorial;


// WEBPACK FOOTER //
// ./src/js/components/tutorial/Tutorial.js